<template>
    <div class="controlSet">
        <div class="page-header">
            <page-header></page-header>
            <div class="set-option">

                <div>
                    <el-button :loading="loading" @click="loadControlConf(false)" type="primary">{{loading ? '正在加载' : '刷新数据'}}</el-button>
                </div>
            </div>
        </div>

        <div class="css-margin-top">
            <el-card class="box-card" body-style="{min-height:'300px'}">
                <loading v-if="loading"></loading>
                <template v-else>

                    <div class="clearfix chars-header">
                        <span class="card-header-title">参数列表</span>
                        <span class="time-show">{{timeShow}}</span>
                        <span></span>
                    </div>
                    <!-- TODO 更好的表单验证方式 -->
                    <div v-if="!isMobile" class="table-list">
                        <template>
                            <el-table :data="tableData.slice(0,Math.round(tableData.length/2))" class="val-table">
                                <el-table-column prop="name" label="参数名">
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <template>
                            <el-table :data="tableData.slice(Math.round(tableData.length/2))" class="val-table">
                                <el-table-column prop="name" label="参数名">
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>

                    <!-- isMobile table -->

                    <div v-if="isMobile" class="table-list">
                        <template>
                            <el-table :data="tableData" class="mobile-val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p style="font-size:14px">{{scope.row.name}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>

                    </div>
                </template>

            </el-card>

        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Lib from "../../lib/lib.js";

    import pageHeader from "../../components/tempControl/header";
    import loading from "../../components/common/loading";

    import _ from "lodash";

    export default {
        name: "autoVal",
        components: {
            pageHeader,
            loading
        },
        data() {
            return {
                isEdit: false,
                option: {
                    sys_alias: ""
                },
                test: "",
                loading: "",
                sys_alias: [],
                val: "",
                confData: [],
                options: [
                    {
                        label: "一号窑",
                        val: 1
                    }
                ],
                tableData: [],
                timeShow: "",
                id_of_setinterval:''
            };
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo,
            config:state=>state.config
        }),
        created() {
            this.option.sys_alias = 1;
            this.checkUpdata();

        },
        mounted() {
            for (let i = 0; i < 1; i++) {
                Lib.M.selectInputFoc();
            }
            this.timingLoadData('OPEN')
        },
        beforeDestroy() {
            this.loading = false;
        },
        methods: {
            // 定时任务
            timingLoadData(type) {
                if (type === "OPEN") {
                    this.id_of_setinterval = setInterval(() => {
                        this.loadControlConf(false);
                    }, this.config.refreshInterval?this.config.refreshInterval:30000);
                } else {
                    clearInterval(this.id_of_setinterval);
                }
            },

            // 检测缓存 没有或超时更新数据
            checkUpdata() {
                let isNew, date;
                this.loadControlConf(true);
            },
            loadControlConf(is_cache) {
                this.confData = [];
                this.loading = true;
                let params = {
                    conf_type: "auto",
                    sys_alias: this.option.sys_alias,
                    device_id: this.deviceInfo.device_id,
                    is_cache: is_cache
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceConf(params, data => {
                    this.loading = false;
                    if (data.status_code === "SUCCEEDED") {
                    } else {
                        this.$message({
                            message: "获取自控变量错误," + data.msg,
                            type: "warning"
                        });
                    }
                    this.timeShow = data.payload.time_stamp;
                    if (data.payload && data.payload.data) {
                        let tableData = JSON.parse(data.payload.data);
                        if (tableData.oother) {
                            delete tableData.oother;
                            if (tableData.msg) {
                                delete tableData.msg;
                                delete tableData.isSuccess;
                            }
                        }
                        this.tableData = [];
                        for (var key in tableData) {
                            if (tableData.hasOwnProperty(key)) {
                                var element = tableData[key];
                                if (key !== "isSuccess" && key !== "msg") {
                                    this.tableData.push({
                                        name: key,
                                        data: element
                                    });
                                }
                            }
                        }
                    } else if (is_cache) {
                        this.loadControlConf(false);
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .body-style {
        min-height: 300px;
    }

    .set-option {
        display: flex;
        justify-content: space-between;
    }

    .table-list {
        display: flex;
        width: 100%;
    }

    .el-card box-card {
        width: 100%;
    }

    .chars-header {
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
    }

    .val-table {
        width: 50%;
    }

    .table-list .el-table__header-wrapper thead div {
        background: #71b7ff;
    }

    .scope-input {
        display: flex;
        align-items: center;
    }

    .scope-input > .el-input {
        flex: 1;
    }

    .scope-input > span {
        margin: 0 5px;
    }

    .edit-input {
        margin: 9px 0;
    }
</style>




// WEBPACK FOOTER //
// autoVal.vue?4662ceb1